// Mensagem pronta para o vendedor quando nenhuma transportadora atende o CEP
// (2026-11-01): o cliente abre o WhatsApp já com o produto e o endereço de
// entrega, e o vendedor vê na hora se dá para entregar. Função pura.

export interface SellerWhatsappProduct {
  name: string;
  url?: string;
  quantity?: number;
  variation?: Array<{ attribute: string; value: string }>;
}

export interface SellerWhatsappAddress {
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
}

function clean(value: string | undefined, max = 160): string {
  return (value ?? "").replace(/\s+/g, " ").trim().slice(0, max);
}

export function formatPostcodeForMessage(postcode: string): string {
  const digits = postcode.replace(/\D/g, "");
  return digits.length === 8 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : clean(postcode, 9);
}

export function buildSellerWhatsappMessage(input: {
  product?: SellerWhatsappProduct;
  postcode: string;
  address?: SellerWhatsappAddress | null;
}): string {
  const lines = ["Olá! Quero receber este produto, mas o site não achou transportadora para o meu CEP."];

  if (input.product && clean(input.product.name)) {
    const variation = (input.product.variation ?? [])
      .map((entry) => clean(entry.value, 60))
      .filter(Boolean)
      .join(", ");
    const quantity = input.product.quantity && input.product.quantity > 1 ? ` — ${input.product.quantity} un.` : "";
    lines.push(`Produto: ${clean(input.product.name)}${variation ? ` (${variation})` : ""}${quantity}`);
    if (input.product.url) lines.push(input.product.url);
  }

  const street = [clean(input.address?.address1), clean(input.address?.address2)].filter(Boolean).join(", ");
  const city = [clean(input.address?.city, 80), clean(input.address?.state, 2).toUpperCase()].filter(Boolean).join("/");
  const place = [street, city].filter(Boolean).join(" — ");
  lines.push(`Entrega: CEP ${formatPostcodeForMessage(input.postcode)}${place ? ` — ${place}` : ""}`);

  lines.push("Vocês conseguem entregar?");
  return lines.join("\n");
}
